// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate as translateHelper } from 'loankeeper-common/helpers'
import { addNote, editNote } from '../../../../../../store/loan'
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { reactForm, FormField } from 'shared/reactForm'
import { withLivedata, withLookups } from 'shared'
import LKButton from 'shared/LKButton'
import { Wrapper } from './modal.style'
import { openFileDetails } from '../../../../../FileDetails'

export const MODAL_NAME = 'LoanReminderAddEditModal'

const translate = (name) => translateHelper(`frm_loan_add_reminder-${name}`)
const translateNotes = (key) => translateHelper('frm_client_notes_add_edit', key)

@LKModalContainer(MODAL_NAME)
@withLivedata(['OpenDayStatus.Open_Day as OpenDay', 'OpenDayStatus.Open_Day_Str as OpenDayStr'])
@withLookups({
  query: ['Nodes', 'RMD_Loan_Priority as Priorities', 'RMD_Types as Types'],
})
@reactForm({
  initialValues: (props) => ({
    StateID: true,
    PriorityID: 1,
    TypeID: 1,
    NodeID: 1,
    LFLID: null,
    GDate: props.OpenDayStr,
    Comment: '',
  }),
})
@connect(undefined, {
  openErrorModal: (messsage) => LKModalActions.openError(messsage),
  openFileDetails,
  addNote,
  editNote,
})
class ReminderModal extends React.Component<any> {
  private isDisabled = false

  constructor(props) {
    super(props)

    this.state = {
      Priorities: this.props.Priorities.map(({ ID, Title }) => ({ value: ID, text: Title })),
      Types: this.props.Types.map(({ ID, Title }) => ({ value: ID, text: Title })),
      Nodes: this.props.Nodes.map(({ ID, Title }) => ({ value: ID, text: Title })),
      OpenDay: new LKDate(this.props.OpenDay).instance.toDate(),
    }

    if (props.productType !== 4) {
      this.state.Types = this.state.Types.filter(({ value }) => value === 1 || value === 3)
    }

    this.LinkedFiles = props.linkedfiles.map(({ ID, Title, TypeTitle }) => ({
      value: ID,
      text: Title,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>{ID}</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>{TypeTitle}</div>
          <div>{Title.substring(0, 10)}</div>
        </div>
      ),
    }))

    this.LinkedFiles.unshift({
      value: '',
      text: '',
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>--</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>--</div>
          <div>--</div>
        </div>
      ),
    })
  }

  componentDidMount() {
    const {
      form,
      params: { data },
    } = this.props

    if (data) {
      form.initialize({
        ...data,
        FileID: data.LFLID,
      })
      this.isDisabled = !!data?.__readonly
    }
  }

  handleTypeIDChange = (_, { value }) => {
    // not sure about this
    this.props.form.changeValues({ TypeID: value })
  }

  submit = (values) => {
    const {
      ID,
      hash,
      params: { data },
      onRefresh,
      closeModal,
      openErrorModal,
      linkedfiles,
    } = this.props

    const { StateID, PriorityID, TypeID, NodeID, GDate, Comment, FileID } = values

    const file = linkedfiles.find((lf) => lf.ID === FileID)

    const HashSum_FileID_ = file ? file.HashSum_FileID_ : null

    const LFLID = FileID

    let promise

    if (data) {
      promise = this.props.editNote({
        LoanID: ID,
        HashSum_LoanID_: hash,
        ID: data.ID,
        StateID: StateID ? 1 : 0,
        PriorityID,
        TypeID,
        NodeID,
        LFLID,
        GDate,
        Comment,
        HashSum_FileID_,
        FileID,
      })
    } else {
      promise = this.props.addNote({
        LoanID: ID,
        HashSum_LoanID_: hash,
        StateID: StateID ? 1 : 0,
        PriorityID,
        TypeID,
        NodeID,
        LFLID,
        GDate,
        Comment,
        FileID,
        HashSum_FileID_,
      })
    }

    return promise
      .then(() => {
        onRefresh()
        closeModal()
      })
      .catch((e) => openErrorModal(e.Error.Message || e.Error.Text))
  }

  handleSubmit = () => this.props.form.handleSubmit(this.submit)

  handleOkBtn = () => {
    this.isDisabled ? this.props.closeModal() : this.handleSubmit()
  }

  isValidFileExtension = () => {
    const { linkedfiles } = this.props

    if (this.props.form.values.FileID || this.props.form.values.LFLID) {
      const file = linkedfiles.find(
        (lf) => lf.ID === this.props.form.values.FileID || lf.ID === this.props.form.values.LFLID,
      )
      return file.Ext.toLowerCase() === 'jpg' || file.Ext.toLowerCase() === 'png' || file.Ext.toLowerCase() === 'pdf'
    }
    return false
  }

  viewFile = () => {
    if (this.props.form.values.FileID || this.props.form.values.LFLID) {
      const file = this.props.linkedfiles.find(
        (lf) => lf.ID === this.props.form.values.FileID || lf.ID === this.props.form.values.LFLID,
      )

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  render() {
    const { modalInstanceName, form } = this.props

    const errors = Object.values(form.errors)

    return (
      <LKModal
        name={modalInstanceName}
        heading={translate('frm_loan_add_reminder')}
        size="sm-1"
        footer={
          <LKModal.Footer>
            <LKBaseButton.Okay onClick={this.handleOkBtn} loading={form.submitting} />
          </LKModal.Footer>
        }
      >
        <Wrapper>
          {errors.length > 0 && (
            <ul className="error-messages">
              {errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          )}

          <div className="reminder-modal__field-container checkbox-field">
            <FormField
              type="checkbox"
              name="StateID"
              form={form}
              label={translate('chk_Active')}
              disabled={this.isDisabled}
            />
          </div>

          <div className="reminder-modal__field-container">
            <div className="reminder-modal__field-label">{translate('lbl_priority')}</div>
            <FormField
              type="select"
              name="PriorityID"
              form={form}
              options={this.state.Priorities}
              disabled={this.isDisabled}
            />
          </div>

          <div className="reminder-modal__field-container">
            <div className="reminder-modal__field-label">{translate('lbl_type')}</div>
            <FormField
              type="select"
              name="TypeID"
              form={form}
              onChange={this.handleTypeIDChange}
              options={this.state.Types}
              disabled={this.isDisabled && !!this.props.params.data}
            />
          </div>

          {form.values.TypeID === 2 && (
            <>
              <div className="reminder-modal__field-container">
                <div className="reminder-modal__field-label">{translate('lbl_date')}</div>
                <FormField type="date" name="GDate" form={form} min={this.state.OpenDay} disabled={this.isDisabled} />
              </div>
              <div className="reminder-modal__field-container">
                <div className="reminder-modal__field-label">{translate('lbl_node')}</div>
                <FormField
                  type="select"
                  name="NodeID"
                  form={form}
                  options={this.state.Nodes}
                  disabled={this.isDisabled}
                />
              </div>
            </>
          )}

          {form.values.TypeID === 3 && (
            <div className="reminder-modal__field-container">
              <div className="reminder-modal__field-label reminder-modal__field-label--short">
                {translateNotes('lbl_file_t')}
              </div>
              <FormField
                type="select"
                name="FileID"
                menuWidth={300}
                form={form}
                options={this.LinkedFiles}
                disabled={this.isDisabled}
              />
              <LKButton
                alias="preview"
                className="preview-icon"
                onClick={this.viewFile}
                disabled={this.isDisabled && !this.isValidFileExtension()}
              />
            </div>
          )}

          <div className="comment-field">
            <FormField type="textarea" name="Comment" form={form} noResize disabled={this.isDisabled} />
          </div>
        </Wrapper>
      </LKModal>
    )
  }
}

export default ReminderModal
